import { httpClient } from '../../httpClient'

export type UserByDepartment = {
  id: string
  name: string
  image: string | null
  department: string | null
}

export type ListUsersByDepartmentParams = {
  departmentId: string
}

export type ListUsersByDepartmentResponse = {
  value: string
  label: string
  avatar: string | null
  department: string | null
}[]

export async function listUsersByDepartment({
  departmentId,
}: ListUsersByDepartmentParams): Promise<ListUsersByDepartmentResponse> {
  const { data } = await httpClient.get<UserByDepartment[]>(
    `/users/by-department?departmentId=${departmentId}`,
  )

  return data.map((user) => ({
    value: user.id,
    label: user.name,
    avatar: user.image ?? null,
    department: user.department ?? null,
  }))
}
